export default __webpack_public_path__ + "static/media/nav_detail_img_16.1829034c.jpg";